export default __webpack_public_path__ + "static/nintex_active-7e48e64ab09c882c11a50b31ea722621.png";